const FileNames = {
  CATERING_CUSTOMERS_SAMPLE: 'Catering_Customers_Sample_Import.xlsx',
  FBZ_CUSTOMERS_SAMPLE: 'FBZ_Customers_Sample_Import.xlsx',
  CATERING_CUSTOMER_GROUPS_SAMPLE:
    'Catering_Customer_Groups_Sample_Import.xlsx',
  FBZ_CUSTOMER_GROUPS_SAMPLE: 'FBZ_Customer_Groups_Sample_Import.xlsx',

  CATERING_CUSTOMER_GROUPS_EXPORT: 'Catering_Customer_Groups_Export.xlsx',
  FBZ_CUSTOMER_GROUPS_EXPORT: 'FBZ_Customer_Groups_Export.xlsx',
  CATERING_CUSTOMERS_EXPORT: 'Catering_Customers_Export.xlsx',
  FBZ_CUSTOMERS_EXPORT: 'FBZ_Customers_Export.xlsx',

  FBZ_INVENTORY_EXPORT: 'FBZ_Inventory_Export.xlsx',
  INVENTORY_SAMPLE_IMPORT: 'Inventory_Sample_Import.xlsx',

  MASTER_DATA_EXPORT: 'MasterData_Export.xlsx',
  MASTER_DATA_SAMPLE_IMPORT: 'Master_data_Sample_Import.xlsx',

  CATERING_ORDERS_EXPORT: 'Catering_Orders_Export.xlsx',
  FBZ_ORDERS_EXPORT: 'FBZ_Orders_Export.xlsx',
  LOGISTICS_ORDERS_EXPORT: 'Logistics_Orders_Export.xlsx',
  CATERING_PICKING_LIST_EXPORT: 'Catering_PickingList_Export.xlsx',
  FBZ_PICKING_LIST_EXPORT: 'FBZ_PickingList_Export.xlsx',
  PRODUCT_SALES_QUANTITY_REPORT_EXPORT: 'Product Sales Quantity Report.xlsx',
  PRODUCT_SALES_ANALYSIS_REPORT_EXPORT: 'Product Sales Analysis Report.xlsx',
  CUSTOMER_SALES_SUMMARY_REPORT_EXPORT: 'customer_sales_summary_report.xlsx',
  FBZ_ORDERS_SAMPLE_IMPORT: 'FBZ_Orders_Sample_Import.xlsx',
  CATERING_ORDERS_SAMPLE_IMPORT: 'Catering_Orders_Sample_Import.xlsx',
  LOGISTICS_ORDERS_SAMPLE_IMPORT: 'Logistics_Orders_Sample_Import.xlsx',

  PRODUCTS_SAMPLE_IMPORT: 'Products_Sample_Import.xlsx',
  LOB_PRODUCTS_EXPORT: 'LOB_Products_EXPORT.xlsx',
  FBZ_PRODUCTS_EXPORT: 'FBZ_Products_EXPORT.xlsx',
};

export default FileNames;
